import React, { useState } from "react";
import { Button, TextField } from "@mui/material";
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';

import axiosInstance from "../../server/axios";

const GradeList = (gradeData) => {
  const grade = gradeData.data.grade;
  const users = gradeData.data.users;
  const modaltitleList = ['Create [New] Grade','Change Grade Name','Change Grade Infomation'];
  const userid = localStorage.getItem('happycallname');

  const checkError = (codeNumber,errordata) => {
    if(codeNumber === 200){return alert("Completed!")}
    if(codeNumber === 201){return alert("Created!")}
    return alert(`Error! code : ${errordata.status}`)
  }
  const getGrade = async () => {
    const gradelist = await axiosInstance.get(`/admin/grade/all?userid=${userid}`);
    gradeData.update({grade:gradelist.data.gradelist,users:gradelist.data.userlist})
  }
  const changeAdmin = async (checkadmin,gradename,userid) => {
    const message = checkadmin === 1 ? `USER Grade : [${gradename}] 을 관리자 권한 해지 하겠습니까?` : `Grade : [${gradename}] 을 관리자 등급 으로 지정 하겠습니까?`;
    if(window.confirm(message)){
      const changeAdmin = await axiosInstance.get(`/admin/changeadmin?userid=${userid}&grade=${gradename}`);
      checkError(changeAdmin.status,changeAdmin);
      getGrade();
    }else{return false;}
  }
  const delGrade = async (_gradename) => {
    const message = `USER Grade : [${_gradename}] 삭제 하시겠습니까 ?`;
    if(window.confirm(message)){
      const gradedeleted = await axiosInstance.delete(`/admin/grade?userid=${userid}&grade=${_gradename}`);
      checkError(gradedeleted.status,gradedeleted);
      getGrade();
    }else{return false;}
  }
  const createGrade = async (_createdGradeName) => {
    const createdGrade = await axiosInstance.post(`/admin/grade`,{userid:userid,grade:_createdGradeName});
    checkError(createdGrade.status,createdGrade);
    getGrade();
  }
  const changedGrade = async (_mode,_gradename,_contents) => {
    const changeGrade = await axiosInstance.patch(`/admin/grade/${_gradename}`,{userid:userid,mode:_mode,contents:_contents});
    checkError(changeGrade.status,changeGrade);
    getGrade();
  }


  const GradeTag = ({gradelist}) => {
    return (
      <tr>
        <td>{gradelist.i+1}</td>
        <td className="rightline">{gradelist.data.grade}</td>
        <td>
        {gradelist.data.grade === 'check' || gradelist.data.grade === 'admin' ?
          <Button variant="contained" color="success" size="big" disabled >변경</Button>            
          :
          <Button variant="contained" color="success" size="big" onClick={()=>handleOpen('name',gradelist.data.grade)} >변경</Button>            
        }
        </td>
        <td className="rightline">{gradelist.data.info}</td>
        <td>
        {gradelist.data.grade === 'check' || gradelist.data.grade === 'admin' ?
          <Button variant="contained" color="success" size="big" disabled >변경</Button>            
          :
          <Button variant="contained" color="success" size="big" onClick={()=>handleOpen('info',gradelist.data.grade)} >변경</Button>            
        }           
        </td>
        <td className="rightline">
        {users.map((val)=>{if(val.grade === gradelist.data.grade){return `${val.user} `}})}
        </td>
        <td>
        {gradelist.data.admin === 1 ?
        <Button variant="contained" color="error" size="big" onClick={()=>changeAdmin(gradelist.data.admin,gradelist.data.grade,userid)}>관리자</Button>
        :
        gradelist.data.grade === 'check' ?
        <Button variant="contained" color="success" size="big" disabled>수정금지</Button>
        :
        <Button variant="contained" color="success" size="big" onClick={()=>changeAdmin(gradelist.data.admin,gradelist.data.grade,userid)}>일반</Button>
        }
        </td>
        <td>
        {gradelist.data.grade === 'check' || gradelist.data.grade === 'admin' ?
          <Button variant="contained" color="error" size="big" disabled>삭제</Button>
          :
          <Button variant="contained" color="success" size="big" onClick={()=>delGrade(gradelist.data.grade) }>삭제</Button>
        }
        </td>
      </tr>
    )
  }
  //modal infomation
  const [open, setOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [gradeSet, setGradeSet] = useState('');
  const [changedData, setChangeData] = useState('');
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 1,
  };
  const handleOpen = (changedTarget,grade) =>{
    let title = 0;
    if(changedTarget === 'name'){title = 1}
    if(changedTarget === 'create'){title = 0}
    if(changedTarget === 'info'){title = 2}
    setModalTitle(modaltitleList[title]);
    setGradeSet([changedTarget,grade])
    setOpen(true);
  };
  const sendChangeData = () => {
    const gradeMode = gradeSet[0];
    const REname = gradeSet[1];
    const GradeContents = changedData;
    if(gradeMode === 'create'){createGrade(GradeContents);}
    if(gradeMode === 'name'){changedGrade('name',REname,GradeContents);}
    if(gradeMode === 'info'){changedGrade('info',REname,GradeContents);}
    handleClose();
  }
  const handleClose = () => setOpen(false);
  const changeGradeData = (event) => {
    setChangeData(event.target.value);
  }
  return (
    <>
      <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      >
      <Box sx={style}>
        <div className="modalbox_grade">
          <div style={{height:'50px',textAlign:'center',fontSize:'2rem',fontWeight:'500',color:'violet'}}>{modalTitle}</div>
          <TextField id="outlined-basic" label="변경 사항 입력" variant="outlined" color="secondary" onChange={changeGradeData}/>
          <Button                
          variant="contained" 
          color="secondary" 
          size="big" 
          onClick={()=>sendChangeData()}
          >Submit</Button>
        </div>
      </Box>
      </Modal>
      <table className="company_main">
        <thead>
          <tr>
            <th>No</th>
            <th>Grade Name</th>
            <th>change <br></br>G Name</th>
            <th>Grade Info</th>
            <th>change <br></br>G Info</th>
            <th>User List</th>
            <th>is Admin ?</th>
            <th>User<br></br>Delete</th>
          </tr>
        </thead>
        <tbody>
          {grade.map( (data,i)=>
            <GradeTag key={data.grade} gradelist={{data,i}}/>
          )}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan={8}>
              <Button 
                variant="contained" 
                color="secondary" 
                size="big" 
                style={{width:'100%',height:'100%'}}
                onClick={()=>handleOpen('create','')}
              >Create New Grade
              </Button>
            </td>
          </tr>
        </tfoot>
      </table>
    </>
    )
}
export default GradeList;